import React, {
    useCallback, useEffect
} from 'react';
import _ from 'lodash';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
// import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import { AdditionalInterestComponent } from "premier-capability-policyjob-react";
import { useUpdateSubmissionServices, validationUtil } from 'premier-capability-hooks';
import { PremierConstants } from 'premier-constant-service';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import styles from '../../SPEventLiabilityStyles.module.scss';
import metadata from './LiabilityCoveragesPage.metadata.json5';
import messages from './LiabilityCoveragesPage.messages'

import CoveragesPageComponent from "../Coverages/CoveragesPage";

function LiabilityCoveragesPage(props) {

    const { wizardData: submissionVM, updateWizardData } = props;
    const { updateSubmission } = useUpdateSubmissionServices();
    const { lineName } = PremierConstants;
    const { authHeader } = useAuthentication();
    const {
        onValidate,
        initialValidation
    } = useValidation('HoleInOnePage');


    useEffect(() => {

    }, []);

    const overrideProps = {
        pscLineCoverageComponent: {
            wizardData: submissionVM,
            updateWizardData,
            clausesBasePath: `lobData.speLinLine.lineCoverages.coverages`,
            title: messages.covMiscellaneous,
            clasueType: 'coverages',
            pathToGet: 'speLinLine.coverages'
        },
        additionalInterest: {
            value: submissionVM,
            path: `lobData.speLinLine.coverables.additionalInterests`,
            type: 'additionalInterest',
            onValueChange: updateWizardData,
            authHeader
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
            CoveragesPageComponent,
            AdditionalInterestComponent
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.pageContent, submissionVM, id, path, overrideProps),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [metadata, submissionVM, overrideProps]
    );


    const isDisableNext = () => !_.isUndefined(_.find(submissionVM.value.lobData.speLinLine.lineCoverages.coverages, { isValid: false }) )
                                    || !submissionVM.lobData.speLinLine.coverables.additionalInterests.aspects.subtreeValid

    const onNext = useCallback(
        async () => {
            const { productCode } = submissionVM.value.baseData;
            const lobLineName = lineName[productCode];

            submissionVM.value = await updateSubmission(lobLineName, 'EventLiabilityPage', submissionVM);

            return submissionVM;

        },
        [lineName, submissionVM, updateSubmission]
    );

    const onSave = useCallback(
        async () => {
            const subVMCopy = _.clone(submissionVM);
            const productCode = _.get(subVMCopy.value, 'baseData.productCode');

            validationUtil.unSetIsValidationReqFlag(subVMCopy.lobData.speLinLine.coverables.eventLiaCoverable.value, ' ');

            const lobLineName = productCode ? lineName[productCode] : '';
            
            await updateSubmission(lobLineName, 'EventLiabilityPage', subVMCopy);

            return submissionVM;
        },
        [lineName, submissionVM, updateSubmission]
    );

    return (
        <WizardPage onNext={onNext} onSave={onSave} skipWhen={initialValidation} disableNext={isDisableNext()}>
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={submissionVM}
                onModelChange={updateWizardData}
                overrideProps={overrideProps}
                onValidationChange={onValidate}
                resolveValue={readValue}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
            />
        </WizardPage>
    );
}

LiabilityCoveragesPage.propTypes = wizardProps;
export default withRouter(LiabilityCoveragesPage);
